import type { BadgeStyleParams } from 'components/ui/atoms/badges/badgeStyle';

export enum COLLECTION_ORDER_STATUS_ENUM {
  RECEIVED = 'received',
  PROCESSING = 'processing',
  PROCESSING_REFUND = 'processing_refund',
  CANCELLED = 'cancelled',
  AUTHORISED = 'authorised',
  PENDING = 'pending',
  ACTION_REQUIRED = 'action_required',
  COMPLETED = 'completed',
  REFUNDED = 'refunded',
  PARTIALLY_REFUNDED = 'partially_refunded',
  ACTION_REQUIRED_FOR_REFUND = 'action_required_for_refund',
  REFUND_RETURNED = 'refund_returned'
}

export const COLLECTION_ORDER_STATUSES: Array<OrderState> = [
  {
    id: COLLECTION_ORDER_STATUS_ENUM.RECEIVED,
    value: 'received',
    order: 1,
    label: 'Received',
    style: {
      color: 'bg-status-neutral',
      activeColor: 'bg-status-neutral-active',
      hover: 'hover:bg-status-neutral-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.PROCESSING,
    value: 'processing',
    order: 2,
    label: 'Processing',
    style: {
      color: 'bg-status-processing',
      activeColor: 'bg-status-processing-active',
      hover: 'hover:bg-status-processing-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.PROCESSING_REFUND,
    value: 'processing_refund',
    order: 3,
    label: 'Processing refund',
    style: {
      color: 'bg-status-processing',
      activeColor: 'bg-status-processing-active',
      hover: 'hover:bg-status-processing-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.CANCELLED,
    value: 'cancelled',
    order: 4,
    label: 'Cancelled',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.AUTHORISED,
    value: 'authorised',
    order: 5,
    label: 'Authorised',
    style: {
      color: 'bg-status-processing',
      activeColor: 'bg-status-processing-active',
      hover: 'hover:bg-status-processing-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.PENDING,
    value: 'pending',
    order: 6,
    label: 'Pending',
    style: {
      color: 'bg-status-pending',
      activeColor: 'bg-status-pending-active',
      hover: 'hover:bg-status-pending-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.ACTION_REQUIRED,
    value: 'action_required',
    order: 7,
    label: 'Action required',
    style: {
      color: 'bg-status-action-required',
      activeColor: 'bg-status-action-required-active',
      hover: 'hover:bg-status-action-required-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.COMPLETED,
    value: 'completed',
    order: 8,
    label: 'Completed',
    style: {
      color: 'bg-status-completed',
      activeColor: 'bg-status-completed-active',
      hover: 'hover:bg-status-completed-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.REFUNDED,
    value: 'refunded',
    order: 9,
    label: 'Refunded',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.PARTIALLY_REFUNDED,
    value: 'partially_refunded',
    order: 10,
    label: 'Partially refunded',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.ACTION_REQUIRED_FOR_REFUND,
    value: 'action_required_for_refund',
    order: 11,
    label: 'Action required for refund',
    style: {
      color: 'bg-status-action-required',
      activeColor: 'bg-status-action-required-active',
      hover: 'hover:bg-status-action-required-active'
    }
  },
  {
    id: COLLECTION_ORDER_STATUS_ENUM.REFUND_RETURNED,
    value: 'refund_returned',
    order: 12,
    label: 'Refund returned',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  }
];
export type OrderState = {
  id: COLLECTION_ORDER_STATUS_ENUM;
  value: string;
  order: number;
  label: string;
  style: BadgeStyleParams;
};
